import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  signal,
  viewChild,
} from '@angular/core';

@Component({
  selector: 'comp-scrollable-card',
  templateUrl: './scrollable-card.component.html',
  styleUrls: ['./scrollable-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.scroll-shadow-top]': 'showTopShadow()',
    '[class.scroll-shadow-bottom]': 'showBottomShadow()',
  },
})
export class ScrollableCardComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly viewport = viewChild.required<ElementRef<HTMLElement>>('viewport');
  private readonly content = viewChild.required<ElementRef<HTMLElement>>('content');

  protected readonly showTopShadow = signal(false);
  protected readonly showBottomShadow = signal(false);

  constructor() {
    afterNextRender(() => {
      const observer = new ResizeObserver(() => this.updateShadows());

      // Observe both available space and asynchronously changing content.
      observer.observe(this.viewport().nativeElement);
      observer.observe(this.content().nativeElement);

      this.updateShadows();
      this.destroyRef.onDestroy(() => observer.disconnect());
    });
  }

  protected updateShadows(): void {
    const { scrollTop, scrollHeight, clientHeight } = this.viewport().nativeElement;
    const hasOverflow = scrollHeight - clientHeight > 1;

    this.showTopShadow.set(hasOverflow && scrollTop > 1);
    this.showBottomShadow.set(hasOverflow && scrollTop + clientHeight < scrollHeight - 1);
  }
}
